import * as THREE from "three"
import Stats from "three/examples/jsm/libs/stats.module"
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
// import { TransformControls } from "three/examples/jsm/controls/TransformControls"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader"
// import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module"
import * as SkeletonUtils from "three/examples/jsm/utils/SkeletonUtils"
import { Water } from 'three/examples/jsm/objects/Water2.js'; // 'three/addons/objects/Water2.js';


import {
    EffectComposer,
    RenderPass,
    EffectPass,
    ToneMappingEffect,
    ToneMappingMode,
    BloomEffect,
    SMAAEffect,
    DepthOfFieldEffect,
    SMAAPreset,
    EdgeDetectionMode,
    PredicationMode,
} from "postprocessing"
import {
    SSAOEffect,
} from "realism-effects"

import { gsap } from "gsap"
import { Pane } from "tweakpane"

//

import {
  isM,
  getRealSize,
  realLoader,
  randomNum,
  randomDec,
} from "../components/alpha"
import { values } from "../components/values"
import { SoundController } from "../classes/soundController"
import { FirstPersonControls } from "../classes/cameraController"
import { FollowPath } from "../classes/followPath"
import { Particles } from "../classes/particles"
import * as mats from '../components/materials.js'


//
// INIT ----------------------------------------------------------------------

const devRot = document.querySelector("#deviceRotated")
isM ? devRot.classList.add("mobile") : devRot.remove()

//

let clock, camera, scene, renderer, composer

const GLTF_loader = new GLTFLoader()
const Env_loader = new RGBELoader()

const appContainer = document.querySelector("#king-home")
const canvas = document.querySelector("#canvas-home")

let stats = false

//
// Load control ----------------------------------------------------------------
const loadControl = {
  finish: false,
  allowLogSize: false,
  elements: {},
}
window.loadControl = loadControl


// ---------------------------------------------------------------------------

const init = async () => {

    console.log(`[3] Scene init`)

    let size = getRealSize(appContainer)

    // ---------------------------------------------------------------------------

    clock = new THREE.Clock()

    scene = new THREE.Scene()
    window.scene = scene

    camera = new THREE.PerspectiveCamera( values.camera.fov, size.w/size.h, 0.1, 45 )
    camera.position.copy( values.camera.pos )
    camera.lookAt( new THREE.Vector3().copy( values.camera.target ) )
    window.camera = camera

    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        // antialias: true,
        // ----Postprocessing
        powerPreference: "high-performance",
        antialias: false,
        stencil: false,
	    depth: false,
        // alpha: true,
    })
    renderer.setPixelRatio( Math.min(window.devicePixelRatio, 2) )
    renderer.setSize( size.w, size.h )
    renderer.physicallyCorrectLights = true
    renderer.outputColorSpace = THREE.SRGBColorSpace
    renderer.outputEncoding = THREE.sRGBEncoding
    renderer.setClearColor(0x00ff00, 0)
    // renderer.shadowMap.enabled = true
    // renderer.shadowMap.type = THREE.VSMShadowMap
    renderer.toneMappingExposure = 1.6 //2.3

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy()


    //
    // Debug UI ------------------------------------------------------------------

    /* const pane = new Pane({
        title: 'Parans',
        expanded: false
    })
    const _params = {
        envMap: 'None'
    }
    pane.addInput(renderer, 'toneMappingExposure', {min: 0.0, max: 3.0, step: 0.1})

    let pf*/

    // const camBtn = pane.addButton({title: 'cam pos'})
    // camBtn.on('click', () => {
    //     console.log(camera.position)
    // })


    //
    // Extras -----
    // scene.add( new THREE.AxesHelper( 10 ) )

    if(stats) {
        stats = new Stats()
        stats.dom.style.cssText = 'top: 5%; position: fixed; z-index: 999999'
        appContainer.appendChild( stats.dom )
    }



    //
    // Controls -----
    // let cameraControl = new OrbitControls(camera, renderer.domElement)
    // cameraControl.target.copy( values.camera.target )

    // const transformControl = new TransformControls( camera, renderer.domElement )
    // transformControl.mode = 'rotate'
    // transformControl.addEventListener( 'dragging-changed', function ( event ) {
    //     cameraControl.enabled = !event.value
    // })
    // transformControl.addEventListener( 'objectChange', () => {
    //     pane.refresh()
    //     // updateSpline()
    // })
    // scene.add( transformControl )

    let cameraControl = new FirstPersonControls(camera, renderer.domElement)
    cameraControl.target.copy( values.camera.target )
    cameraControl.enabled = false


    
    //
    // Sound ------------------------------------------------------------------
    const sound = new SoundController(camera)
    sound.load([
        'fx',
        'button',
        'water'
    ])


    
    //
    // EnvMap ------------------------------------------------------------------
    // const envObj = ["sunrise", "tombs", "hilly_terrain"]
    const envObj = ["tombs_small", "tombs"]
    Env_loader.load(`./assets/glb/envMap/${envObj[0]}.hdr`,
        (env) => {
            env.mapping = THREE.EquirectangularReflectionMapping
            scene.background = env
            scene.environment = env
        },
        (xhr) => {
            loadControl.elements.envMap = { loaded: xhr.loaded, total: xhr.total }
            if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`EnvMap "${envObj[randomNum(0,2)]}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
        },
        (error) => {
            console.warn(`EnvMap: Error loading`)
            // console.warn( error )
        }
    )


    /*pane.addInput(_params, 'envMap', {
        options: {
            none: 'None',
            sunrise: 'sunrise',
            Tombs: 'tombs',
            hilly: 'hilly_terrain',
        }
    }).on('change', (e) => {
        Env_loader.load(`./assets/glb/envMap/${e.value}.hdr`,
            (env) => {
                env.mapping = THREE.EquirectangularReflectionMapping
                scene.background = env
                scene.environment = env
            }
        )
    })*/



    // GLTF ------------------------------------------------------------------
    // gltfpack -c -vt 14 -vn 10 -kn -i ./dist/assets/glb/01.glb -o ./dist/assets/glb/01c.glb
    const allMixers = []
    async function loadGLTFasync(name) {
        const url = `./assets/glb/${name}.glb`
        const gltf = await GLTF_loader.loadAsync(url,
            (xhr) => {
                loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
            })
        return gltf
    }

    //
    let navmesh
    let sceneButtons = []
    loadGLTFasync('Mujeres_v3').then( sceneGltf => {  

        const mujeresScene = sceneGltf.scene
        mujeresScene.rotation.y = Math.PI

        let count = 0
        mujeresScene.traverse( obj => {
            //
            if (obj.name.includes('Palmera_')) {
                obj.renderOrder = 2
                obj.material.alphaTest = 0.44
            }

            if (obj.name.includes('PortalName')) {

                gsap.to(obj.rotation, {
                    y: `+=${Math.PI * 2}`,
                    duration: 24,
                    ease: 'none',
                    repeat: -1
                })
            }

            if (obj.name.includes('Boton_')) {
                //
                obj.material.map.anisotropy = maxAnisotropy
                sceneButtons.push(obj)
            }

            //

            if (obj.name.includes('FotoJardines_Cauca_')) obj.material = mats.jardinCaucaMat
            if (obj.name.includes('FotoJardines_Choco_')) obj.material = mats.jardinChocoMat
            if (obj.name.includes('FotoJardines_Narino_')) obj.material = mats.jardinNarinoMat
            if (obj.name.includes('FotoJardines_Valle_')) obj.material = mats.jardinValleMat

            if (obj.name === 'FotoCauca_A') obj.material = mats.caucaA_Mat
            if (obj.name === 'FotoCauca_B') obj.material = mats.caucaB_Mat
            if (obj.name === 'FotoCauca_C') obj.material = mats.caucaC_Mat
            if (obj.name === 'FotoCauca_D') obj.material = mats.caucaD_Mat

            if (obj.name === 'FotoChoco_A') obj.material = mats.chocoA_Mat
            if (obj.name === 'FotoChoco_B') obj.material = mats.chocoB_Mat
            if (obj.name === 'FotoChoco_C') obj.material = mats.chocoC_Mat
            if (obj.name === 'FotoChoco_D') obj.material = mats.chocoD_Mat

            if (obj.name === 'FotoValle_A') obj.material = mats.valleA_Mat
            if (obj.name === 'FotoValle_B') obj.material = mats.valleB_Mat
            if (obj.name === 'FotoValle_C') obj.material = mats.valleC_Mat
            if (obj.name === 'FotoValle_D') obj.material = mats.valleD_Mat
        })

        const piso = mujeresScene.getObjectByName('Piso_principal')
        piso.material.normalMap.anisotropy = maxAnisotropy/2

        // Navmesh
        navmesh = mujeresScene.getObjectByName('Navmesh')
        navmesh.visible = false
        cameraControl.navMesh = navmesh

        /*const mixer = glbControl.mixer = new THREE.AnimationMixer(model)
        allMixers[glb_objeto] = mixer

        const clips = gltf.animations
        // clips.forEach( clip => {
        //     // console.log( clip.name.toLowerCase() )
        //     const action = glbControl.actions[ clip.name.toLowerCase() ] = mixer.clipAction( clip )
        //     // action.clampWhenFinished = true
        //     // action.loop = THREE.LoopOnce
        //     // action.weight = 0
        // })

        //
        // Mixer ---------
        mixer.addEventListener( 'finished', function( e ) {
            const clipName = e.action._clip.name
            // console.log(clipName)

            // Eliminar mixer
            // delete allMixers[glb_objeto]
        })
        */

        scene.add(mujeresScene)
    })
    
    //
    // Animals    
    function createStaticCurve( points ) {

        const addVisual = false

        const ARC_SEGMENTS = 8*6
        const point = new THREE.Vector3()
        const curve = new THREE.CatmullRomCurve3( points, true, 'catmullrom', 0.8 )

        //
        let data = []
        let sec
        for ( let i = 0; i < ARC_SEGMENTS; i ++ ) {
            const t = i / ( ARC_SEGMENTS - 1 )
            curve.getPoint( t, point )
            data.push(point.x, point.y, point.z)
            if( i === 1 ) sec = point.clone()
        }

        const geometry = new THREE.BufferGeometry()
        geometry.setAttribute('position', new THREE.BufferAttribute( new Float32Array(data), 3 ))

        if(addVisual) {
            scene.add( new THREE.Line( geometry, new THREE.LineBasicMaterial({ color: Math.random() * 0xffffff }) ) )
                //
            const boxGeo = new THREE.BoxGeometry( 0.5, 0.5, 0.5 )

            const object = new THREE.Mesh( boxGeo.clone(), new THREE.MeshStandardMaterial({ color: 0x0000ff }) )
            object.scale.set(0.5, 0.5, 0.5)
            object.position.copy( points[0] )
            const object2 = new THREE.Mesh( boxGeo.clone(), new THREE.MeshStandardMaterial({ color: 0x000f0f }) )
            object2.scale.set(0.25, 1, 0.25)
            object2.position.copy( sec )
            scene.add( object, object2 )
        }

        return curve
    }
    const followController = new FollowPath()
    loadGLTFasync('Guacamaya').then( guacamayaGlft => {
        const animalsCurves = [
            [ new THREE.Vector3(9.58, 7.30, -11.10), new THREE.Vector3(10.98, 4.96, 0.04), new THREE.Vector3(10.55, 8.19, 14.61), new THREE.Vector3(0.23, 6.27, 21.82), new THREE.Vector3(-3.77, 4.44, 11.54), new THREE.Vector3(1.24, 3.08, 0.01), new THREE.Vector3(-8.19, 1.81, -7.18), new THREE.Vector3(-2.16, 5.86, -12.82)
            ], [ new THREE.Vector3(-9.35, 4.12, -9.61), new THREE.Vector3(-2.76, 5.29, -16.52), new THREE.Vector3(8.45, 4.32, -9.52), new THREE.Vector3(20.08, 5.24, -0.76), new THREE.Vector3(11.21, 4.46, 8.14), new THREE.Vector3(0.91, 1.82, 12.66), new THREE.Vector3(-9.83, 3.32, 9.68), new THREE.Vector3(-13.68, 4.22, -0.07)
            ], [ new THREE.Vector3(-16.41, 8.18, -4.83), new THREE.Vector3(-9.87, 6.03, 9.60), new THREE.Vector3(4.45, 7.57, 13.91), new THREE.Vector3(7.68, 3.30, -3.26), new THREE.Vector3(-3.56, 1.30, -1.74), new THREE.Vector3(3.28, 3.84, 7.38), new THREE.Vector3(12.80, 3.72, -5.22), new THREE.Vector3(-0.17, 6.19, -18.36)
            ], [ new THREE.Vector3(-9.84, 1.51, 9.91), new THREE.Vector3(0.15, 6.94, 12.92), new THREE.Vector3(10.02, 1.79, 10.13), new THREE.Vector3(15.22, 3.99, -0.07), new THREE.Vector3(10.31, 4.48, -11.75), new THREE.Vector3(-0.36, 5.16, -12.07), new THREE.Vector3(-8.33, 3.43, -7.34), new THREE.Vector3(-12.00, 2.58, 0.63)
            ], [ new THREE.Vector3(3.87, 7.09, 19.81), new THREE.Vector3(15.86, 8.98, 11.43), new THREE.Vector3(18.21, 7.76, -0.17), new THREE.Vector3(13.21, 7.23, -13.16), new THREE.Vector3(-0.42, 9.31, -19.20), new THREE.Vector3(-14.25, 7.26, -12.97), new THREE.Vector3(-18.57, 8.05, 0.98), new THREE.Vector3(-7.95, 4.76, 8.23) ]
        ]
        for (let i = 0; i < animalsCurves.length; i++) {

            const curve = createStaticCurve(animalsCurves[i] )

            //
            const model = SkeletonUtils.clone( guacamayaGlft.scene )
            const sf = randomNum(1.5, 2)
            model.scale.set(sf, sf, sf)
            scene.add(model)

            const mixer = new THREE.AnimationMixer(model)
            mixer.timeScale = 0.85
            const clip = guacamayaGlft.animations[0]
            mixer.clipAction(clip).play()
            allMixers.push(mixer)

            //
            followController.add( curve, model, randomNum(20,25) )
        }
    })

    //
    loadGLTFasync('Colibri').then( colibriGltf => {
        const colibrisData = {
            pos: [
                new THREE.Vector3(1.56, 3.17, -3.54),
                // new THREE.Vector3(1.10, 1.37, -2.72),
                // new THREE.Vector3(3.22, 1.97, -1.20),
                new THREE.Vector3(-0.77, 2.15, -3.16),
                // new THREE.Vector3(0.30, 3.33, -0.43),
                // new THREE.Vector3(2.67, 2.62, 2.08),
                new THREE.Vector3(-2.57, 2.47, 1.13),
                // new THREE.Vector3(-0.26, 2.43, 1.40),
                new THREE.Vector3(1.26, 2.71, 3.37),
                new THREE.Vector3(1.94, 3.90, 0.84)
            ],
            quat: [
                new THREE.Quaternion(-0.05, 0.81, -0.05, 0.59),
                // new THREE.Quaternion(0.05, 0.70, 0.10, 0.71),
                // new THREE.Quaternion(0.08, 0.34, 0.15, 0.93),
                new THREE.Quaternion(0.18, -0.50, -0.10, 0.84),
                // new THREE.Quaternion(0.01, 0.32, -0.17, 0.93),
                // new THREE.Quaternion(0.08, -0.92, 0.04, -0.38),
                new THREE.Quaternion(-0.06, -0.58, 0.12, 0.80),
                // new THREE.Quaternion(0.08, -0.86, 0.08, 0.49),
                new THREE.Quaternion(0.14, -0.65, -0.14, 0.73),
                new THREE.Quaternion(0.13, 0.70, 0.13, 0.69)
            ]
        } 
        for (let i = 0; i < colibrisData.pos.length; i++) {
            //
            const model = SkeletonUtils.clone( colibriGltf.scene )
            const sf = randomDec(0.4, 0.8)
            model.scale.set(sf, sf, sf)
            model.position.copy( colibrisData.pos[i] )
            model.quaternion.copy( colibrisData.quat[i] )
            scene.add(model)

            const mixer = new THREE.AnimationMixer(model)
            mixer.timeScale = randomDec(2, 3)
            const clip = colibriGltf.animations[0]
            mixer.clipAction(clip).play()

            allMixers.push(mixer)
        }
    })
    

    


    // Particles ------------------------------------------------------------------
    /*// let gu = { time: {value: 0} }

    const pNarino = new Particles(gu, 60, 4)
    pNarino.position.set(20,0,0)
    const pValle = new Particles(gu, 60, 4)
    pValle.position.set(-20,0,0)
    const pChoco = new Particles(gu, 60, 4)
    pChoco.position.set(0,0,20)
    const pCauca = new Particles(gu, 60, 4)
    pCauca.position.set(0,0,-20)
    scene.add( pNarino, pValle, pChoco, pCauca )

    // const pCentral = new Particles(gu, 60, 4, 0.5)
    // scene.add( pCentral )
    */


    //
    // APP ------------------------------------------------------------------
    //

    function loadCallback() {
       
        gsap.to('.loader', {
            opacity: 0, scale: 1.25,
            delay: 0.5, duration: 1.25, ease: 'power1.in',
            onComplete() { this.targets()[0].remove() }
        })

        cameraControl.splashToStart()
    }


    // Init sound in first clic
    function firstClic() {

        sound.init()
        sound.play('fx', true, 0.35)
        sound.initPositional('water', true, 0.65, waterMeshSound, 4.5, 4)

        window.removeEventListener('pointerup', firstClic)
    }
    window.addEventListener('pointerup', firstClic)



    // Buttons interaction
    const raycaster = new THREE.Raycaster()
    const mousePos = new THREE.Vector2()
    let buttonsInt
    let buttonsSound
    let lastButton
    canvas.addEventListener('mousemove', (e) => {

        if( cameraControl.enabled === false ) return 

        mousePos.x = (e.clientX / window.innerWidth) * 2 - 1
        mousePos.y = -(e.clientY / window.innerHeight) * 2 + 1

        raycaster.far = 15
        raycaster.setFromCamera(mousePos, camera)
        buttonsInt = raycaster.intersectObjects(sceneButtons)
        if( buttonsInt.length > 0 ) {
            document.body.style.cursor = 'pointer'

            if( !buttonsSound ) {
                sound.play('button', false, 1)
                lastButton = buttonsInt[0].object
                lastButton.scale.set(2, 2, 2)
            }
            buttonsSound = true
        } else {
            if( buttonsSound && lastButton ) {
                lastButton.scale.set(1.5, 1.5, 1.5)
                lastButton = undefined
            }
            buttonsSound = false
        }
    })
    canvas.addEventListener('mouseup', (e) => {

        if( cameraControl.enabled === false ) return

        if( buttonsInt.length > 0 ) {
            const [,name] = buttonsInt[0].object.name.split('_')
            // alert(name)
            window.regionsPopup(name)
        }
    })


    // Help
    let animatingHelp
    const helpButton = document.querySelector('.UI-help')
    helpButton.addEventListener('pointerup', () => {

        if( animatingHelp ) return
        
        if(!helpButton.classList.contains('active')) {

            animatingHelp = true

            helpButton.classList.add('active')
            document.body.removeAttribute('style')
            cameraControl.enabled = false

            gsap.to('.help', {
                opacity: 1,
                duration: 0.65,
                ease: 'power1.out',
                onStart() {
                    this.targets()[0].style.display = 'flex'
                },
                onComplete() {
                    animatingHelp = false
                }
            })
        }
    })

    document.querySelector('.help-close').addEventListener('pointerup', () => {

        if( animatingHelp ) return
        animatingHelp = true

        //
        gsap.to('.help', {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            onComplete() {
                animatingHelp = false
                document.querySelector('.UI-help').classList.remove('active')
                this.targets()[0].style.display = 'none'
            }
        })

        cameraControl.enabled = true

        sessionStorage.setItem('help', true)
    })


    // Water sound
    const waterMeshSound = new THREE.Mesh(
        new THREE.BoxGeometry(0.4, 0.4, 0.4),
        new THREE.MeshBasicMaterial({
            // colorWrite: false,
        })
    )
    waterMeshSound.position.set(0,0.5,0)
    waterMeshSound.visible = false
    scene.add( waterMeshSound )

    // Water mesh
    const waterGeo = new THREE.CircleGeometry(1.45, 16)
    const water = new Water( waterGeo, {
        color: '#b4f7ff', // '#ffffff',
        scale: 0.3,
        reflectivity: 0.05,
        flowSpeed: 0.04,
        flowDirection: new THREE.Vector2( randomDec(-1, 1), randomDec(-1, 1) ),
        textureWidth: 512,
        textureHeight: 512,
        normalMap0: mats.imagesLoader('/water/Water_1_M_Normal.jpg'),
        normalMap1: mats.imagesLoader('/water/Water_2_M_Normal.jpg'),
    })
    water.position.set(0.15, 0.35, 0.1)
    water.rotation.x = Math.PI * -0.5;
    scene.add( water )





    //
    // Render ------------------------------------------------------------------

    composer = new EffectComposer(renderer, {
        frameBufferType: THREE.HalfFloatType,
    })

    const renderPass = new RenderPass(scene, camera)

    // const noiseEffect = new NoiseEffect({ premultiply: true })
    // noiseEffect.blendMode.opacity.value = 0.5

    const dofParams = {
        // worldFocusDistance,
        // worldFocusRange,
        focusDistance: 0.20,
        focusRange: 0.65,
        // focalLength: 0.1,
        bokehScale: 6.0
    }
    const dofEffect = new DepthOfFieldEffect(camera, dofParams)
    /*pf = pane.addFolder({title: 'DoF', expanded: false })
    pf.addInput(dofParams, 'focusDistance', { min: 0.0, max: 1.0, step: 0.01 }).on('change', (e) => {
        dofEffect.circleOfConfusionMaterial.uniforms.focusDistance.value = e.value
    })
    pf.addInput(dofParams, 'focusRange', { min: 0.0, max: 1.0, step: 0.01 }).on('change', (e) => {
        dofEffect.circleOfConfusionMaterial.uniforms.focusRange.value = e.value
    })
    pf.addInput(dofParams, 'bokehScale', { min: 0.0, max: 10.0, step: 0.01 }).on('change', (e) => {
        dofEffect.bokehScale = e.value
    })
    // pf.addInput(dofParams, 'focalLength', { min: 0.0, max: 1.0, step: 0.01 }).on('change', (e) => {
    //     dofEffect.circleOfConfusionMaterial.uniforms.focalLength.value = e.value
    // })
    // pf.addInput(dofParams, 'intensity', {
    //     min: 0.0, max: 2.0, step: 0.05
    // })
    // pf.addInput(dofParams.mipmapBlurPass, 'radius', {
    //     min: 0.0, max: 1.0, step: 0.05
    // })
    // pane.addSeparator()
    */

    const toneMappingEffect = new ToneMappingEffect({
        mode: ToneMappingMode.OPTIMIZED_CINEON,
    })

    const bloomEffect = new BloomEffect({
        luminanceThreshold: 0.95,
        luminanceSmoothing: 0.015,
        intensity: 0.25,
        mipmapBlur: true,
        radius: 0.6
    })
    /*
    // pf = pane.addFolder({title: 'Bloom', expanded: false})
    // pf.addInput(bloomEffect.luminanceMaterial, 'smoothing', {
    //     min: 0.0, max: 1.0, step: 0.025
    // })
    // pf.addInput(bloomEffect, 'intensity', {
    //     min: 0.0, max: 2.0, step: 0.05
    // })
    // pf.addInput(bloomEffect.mipmapBlurPass, 'radius', {
    //     min: 0.0, max: 1.0, step: 0.05
    // })
    // pane.addSeparator()
    */

    const smaaParams = {
        preset: SMAAPreset.ULTRA,
        edgeDetectionMode: EdgeDetectionMode.COLOR,
        predicationMode: PredicationMode.DEPTH,
    }
    const smaaEffect = new SMAAEffect(smaaParams)

    // SSAO
    const ssaoEffect = new SSAOEffect(composer, camera, scene)
    ssaoEffect.blendMode.opacity.value = 0.8

    
    //
    const nPass = new EffectPass(
        camera,
        // ssaoEffect,
        smaaEffect,
        // noiseEffect,
        dofEffect, 
        bloomEffect,
        toneMappingEffect,
    )

    composer.addPass(renderPass)
    composer.addPass(nPass)


    // ---------------------------------------------------------------------------

    function onWindowResize() {
        if(!isM) size = getRealSize(appContainer)
        camera.aspect = size.w / size.h
        camera.updateProjectionMatrix()
        composer.setSize( size.w, size.h )
    }
    window.addEventListener( 'resize', onWindowResize, false)

    window.addEventListener("contextmenu", (e) => e.preventDefault())

    // ---------------------------------------------------------------------------

    function animate() {

        setTimeout( () => {
            requestAnimationFrame( animate )
        }, 1000 / 30 )

        if( loadControl.finish === false ) realLoader(clock, loadCallback)
        if( stats ) stats.update()

        //
        const delta = clock.getDelta()

        for (let i = 0; i < allMixers.length; i++) allMixers[i].update(delta)
        followController.update()
        // gu.time.value = clock.getElapsedTime()
        cameraControl.update(delta)
        composer.render(delta)
    }
    animate()
    
}

export { init }